const aboutTabs = [
    {
        id: 1,
        label: 'about.tabs.header.tab1',
    },
    {
        id: 2,
        label: 'about.tabs.header.tab2',
    },
];

const aboutContentBlocks = [
    {
        id: 1,
        title: 'about.blocks.title-1',
        text: 'about.blocks.text-1',
    },
    {
        id: 2,
        title: 'about.blocks.title-2',
        text: 'about.blocks.text-2',
    },
    {
        id: 3,
        title: 'about.blocks.title-3',
        text: 'about.blocks.text-3',
    },
    {
        id: 4,
        title: 'about.blocks.title-5',
        text: 'about.blocks.text-5',
    },
    {
        id: 5,
        title: 'about.blocks.title-4',
        text: 'about.blocks.text-4',
    },
];

export default {
    aboutTabs,
    aboutContentBlocks
}